
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AnalyzerLogo',
  props: {
    analyzerLogo: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    shortcode: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'base'
    },
    hideTooltip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sizeStyle() {
      const sizes: Record<string, string> = {
        'xx-small': 'w-2.5 h-2.5',
        'x-small': 'w-3 h-3',
        small: 'w-4 h-4',
        base: 'w-5 h-5',
        medium: 'w-6 h-6',
        large: 'w-8 h-8'
      }

      return sizes[this.size] || 'w-5 h-4'
    }
  }
})
